<template>
  <div class="content">
    <div
      class="md-layout"
      style="display: flex; align-items: center; padding-top: 100px"
    >
      <div
        class="md-layout-item md-medium-size-100 md-size-40"
        style="margin: 0 auto"
      >
        <div class="md-layout-item text-center" style="margin-bottom: 40px">
          <img src="../../assets/img/buypower-logo.png" style="width: 50%" />
        </div>
        <form @submit.prevent="requestForget()" v-if="formState === 'initial'">
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">Forget Password</h4>
              <p class="category">Enter Details To Continue</p>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Phone Number</label>
                    <md-input type="text" v-model="username"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-center">
                  <md-button
                    class="md-raised md-primary"
                    data-background-color="orange"
                    type="submit"
                    >Forget Password</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>

        <form @submit.prevent="submitOTP()" v-else-if="formState === 'otp'">
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">Enter OTP</h4>
              <p class="category">Enter the OTP sent to your email/phone</p>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>OTP</label>
                    <md-input type="text" v-model="otp"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-center">
                  <md-button
                    class="md-raised md-primary"
                    data-background-color="orange"
                    type="submit"
                  >Submit OTP</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>

        <form @submit.prevent="updatePassword()" v-else-if="formState === 'update'">
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">Update Password</h4>
              <p class="category">Enter New Password</p>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Password</label>
                    <md-input type="text" v-model="password"></md-input>
                  </md-field>
                  <md-field>
                    <label>Confirm Password</label>
                    <md-input type="password" v-model="checker"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-center">
                  <md-button
                    class="md-raised md-primary"
                    data-background-color="orange"
                    type="submit"
                  >Submit OTP</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>

        <div class="text-center"><span>&copy; 2018 Buypower Inc.</span></div>
      </div>
    </div>

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>

</template>

<script>
import http from '../../utils/Http.util';

export default {
  name: 'Forget',
  data() {
    return {
      snackBar: {
        show: false,
        message: null,
      },
      identityData: {
        phone: '',
        email: '',
        length: 8,
      },
      username: null,
      formState: 'initial',
      otp: null,
      password: null,
      checker: null,
    };
  },
  methods: {
    async requestForget() {
      this.$store.commit('busyStatus', true);

      if (this.username.includes('@')) {
        this.identityData.email = this.username;
      } else {
        this.identityData.phone = this.username;
      }
      try {
        const response = await http.req(
          '/dashboard/password-reset',
          this.identityData,
          'post',
        );

        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message: response.message,
        };

        this.formState = 'otp';
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
        this.$store.commit('busyStatus', false);
      }
    },

    async submitOTP() {
      this.$store.commit('busyStatus', true);

      try {
        const response = await http.req(
          `/dashboard/password-reset?token=${this.otp}`,
          {},
          'get',
        );
        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message: response.message,
        };

        this.formState = 'update';
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
        this.$store.commit('busyStatus', false);
      }
    },

    async updatePassword() {
      this.$store.commit('busyStatus', true);

      try {
        if (this.checker !== this.password) {
          throw new Error('The passwords you entered do not match. Please try again.');
        }
        const response = await http.req(
          `/dashboard/password-reset?token=${this.otp}`,
          {
            password: this.password,
          },
          'put',
        );
        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message: response.message,
        };

        setTimeout(() => {
          this.$router.push({ path: '/' });
        }, 6000);
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
        this.$store.commit('busyStatus', false);
      }
    },
  },
};

</script>
